import _ from 'lodash';
import { FETCH_POSTS_SUCCESS } from '../actions/fetch-posts';
import { FETCH_USER_POSTS_SUCCESS } from '../actions/fetch-posts-by-owner-id';
import { FETCH_COMMENTS_SUCCESS } from '../actions/fetch-comments';
import { getLastPage } from '../services/pagination';
import { COMMENTS_PER_PAGE } from '../constants/pagination';
import { FETCH_COMMENT_SUCCESS } from '../actions/fetch-comment';
import { CREATE_COMMENT_SUCCESS } from '../actions/create-comment';
import { NEW_COMMENT } from '../actions/comment-socket';
import { DELETE_COMMENT_SUCCESS } from '../actions/delete-comment';
import { DELETE_POST_SUCCESS } from '../actions/delete-post';
import { MOVE_POST_SUCCESS } from '../actions/move-post';

const initialState = {
  comments: {
    entitiesByPage: {},
    entityCount: 0,
  },
  posts: {
    entitiesByPage: {},
    entityCount: 0,
  },
};

const getNewEntities = (state, entities, meta) => ({
  entitiesByPage: {
    [meta.page]: entities.map(entity => entity._id),
  },
  entityCount: meta.entityCount,
});

const appendComment = (state, comment) => {
  const newEntityCount = state.entityCount + 1;
  const lastPage = getLastPage(newEntityCount, COMMENTS_PER_PAGE);
  const tempEntities = state.entitiesByPage[lastPage] || [];
  return {
    ...state.comments,
    entitiesByPage: {
      ...state.entitiesByPage,
      [lastPage]: [...tempEntities, comment._id],
    },
    entityCount: newEntityCount,
  };
};

const removePost = (entitiesByPage, deletedPostId) =>
  _.reduce(
    entitiesByPage,
    (acc, ids, page) => ({
      ...acc,
      [page]: _.filter(ids, postId => postId !== deletedPostId),
    }),
    {}
  );

export default (state = initialState, { type, payload, meta = {} } = {}) => {
  switch (type) {
    case FETCH_USER_POSTS_SUCCESS:
    case FETCH_POSTS_SUCCESS:
      return {
        ...state,
        posts: getNewEntities(state.posts, payload, meta),
      };
    case MOVE_POST_SUCCESS:
    case DELETE_POST_SUCCESS:
      return {
        ...state,
        posts: {
          entitiesByPage: removePost(state.posts.entitiesByPage, payload),
          entityCount: state.posts.entityCount - 1,
        },
      };
    case FETCH_COMMENTS_SUCCESS:
      return {
        ...state,
        comments: getNewEntities(state.comments, payload.comments, meta),
      };
    case CREATE_COMMENT_SUCCESS:
    case NEW_COMMENT:
      return {
        ...state,
        comments: appendComment(state.comments, payload),
      };
    case FETCH_COMMENT_SUCCESS:
      return {
        ...state,
        comments: appendComment(state.comments, payload.comment),
      };
    case DELETE_COMMENT_SUCCESS:
      return {
        ...state,
        comments: {
          ...state.comments,
          entityCount: state.comments.entityCount - 1,
        },
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./app/reducers/pagination.js